 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"home-view-Contact-vue":"home-view-Contact-vue","home-view-ContentDetail-vue":"home-view-ContentDetail-vue","home-view-FoundationProfile-vue":"home-view-FoundationProfile-vue","home-view-Ikamaku-vue":"home-view-Ikamaku-vue","home-view-OrganizationStructure-vue":"home-view-OrganizationStructure-vue","home-view-UnitProfile-vue":"home-view-UnitProfile-vue","home-view-ContentList-vue":"home-view-ContentList-vue","npm.cropperjs":"npm.cropperjs","siakad-AdmissionChildren-vue~siakad-Attendance-vue~siakad-AttendanceAndAgenda-vue~siakad-ChildrenDet~58a56ef4":"siakad-AdmissionChildren-vue~siakad-Attendance-vue~siakad-AttendanceAndAgenda-vue~siakad-ChildrenDet~58a56ef4","siakad-ChildrenDetail-vue~siakad-ParentDetail-vue~siakad-Siakad-vue":"siakad-ChildrenDetail-vue~siakad-ParentDetail-vue~siakad-Siakad-vue","siakad-ChildrenDetail-vue":"siakad-ChildrenDetail-vue","siakad-ParentDetail-vue":"siakad-ParentDetail-vue","siakad-Siakad-vue":"siakad-Siakad-vue","npm.v-calendar":"npm.v-calendar","npm.popperjs":"npm.popperjs","siakad-Attendance-vue":"siakad-Attendance-vue","siakad-AttendanceAndAgenda-vue":"siakad-AttendanceAndAgenda-vue","siakad-AdmissionChildren-vue":"siakad-AdmissionChildren-vue","siakad-ChildrenHistory-vue":"siakad-ChildrenHistory-vue","siakad-Agenda-vue":"siakad-Agenda-vue","siakad-ClassHistory-vue":"siakad-ClassHistory-vue","siakad-EkstrakurikulerHistory-vue":"siakad-EkstrakurikulerHistory-vue","siakad-FriendHistory-vue":"siakad-FriendHistory-vue","siakad-HelpCenter-vue~siakad-Suggestions-vue":"siakad-HelpCenter-vue~siakad-Suggestions-vue","siakad-HelpCenter-vue":"siakad-HelpCenter-vue","siakad-Suggestions-vue":"siakad-Suggestions-vue","siakad-PaymentHistory-vue":"siakad-PaymentHistory-vue","siakad-SubjectHistory-vue":"siakad-SubjectHistory-vue","siakad-SubjectList-vue":"siakad-SubjectList-vue","view-ForgetPassword-vue":"view-ForgetPassword-vue","view-Login-vue":"view-Login-vue","view-RegistrationForm-vue":"view-RegistrationForm-vue","view-Verify-vue":"view-Verify-vue","siakad-FaqDetail-vue":"siakad-FaqDetail-vue","siakad-Report-vue":"siakad-Report-vue","view-Logout-vue":"view-Logout-vue","view-Welcome-vue":"view-Welcome-vue"}[chunkId]||chunkId) + "." + {"home-view-Contact-vue":"05bd6aaf","home-view-ContentDetail-vue":"2c7831cf","home-view-FoundationProfile-vue":"6977de73","home-view-Ikamaku-vue":"eb93b02e","home-view-OrganizationStructure-vue":"2a69c3f0","home-view-UnitProfile-vue":"0cc244f9","home-view-ContentList-vue":"8ea57243","npm.cropperjs":"484cd208","siakad-AdmissionChildren-vue~siakad-Attendance-vue~siakad-AttendanceAndAgenda-vue~siakad-ChildrenDet~58a56ef4":"ac10758b","siakad-ChildrenDetail-vue~siakad-ParentDetail-vue~siakad-Siakad-vue":"f0cf0596","siakad-ChildrenDetail-vue":"b0c2b39c","siakad-ParentDetail-vue":"ec869267","siakad-Siakad-vue":"8eff6820","npm.v-calendar":"e931cd34","npm.popperjs":"2d3e2639","siakad-Attendance-vue":"833be4fe","siakad-AttendanceAndAgenda-vue":"9fa116b0","siakad-AdmissionChildren-vue":"bd3b3ff3","siakad-ChildrenHistory-vue":"de8e1fdb","siakad-Agenda-vue":"00566bbe","siakad-ClassHistory-vue":"3cd8b970","siakad-EkstrakurikulerHistory-vue":"49582d33","siakad-FriendHistory-vue":"053ed0a5","siakad-HelpCenter-vue~siakad-Suggestions-vue":"99849ef7","siakad-HelpCenter-vue":"588d714d","siakad-Suggestions-vue":"63997e07","siakad-PaymentHistory-vue":"b496d1b6","siakad-SubjectHistory-vue":"44382c25","siakad-SubjectList-vue":"6347fda9","view-ForgetPassword-vue":"836ac80a","view-Login-vue":"946795b2","view-RegistrationForm-vue":"61d49705","view-Verify-vue":"33a1468b","siakad-FaqDetail-vue":"5a6fdd3f","siakad-Report-vue":"27f929ca","view-Logout-vue":"8712ec80","view-Welcome-vue":"1ea7778f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"npm.cropperjs":1,"view-Verify-vue":1,"view-Logout-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"home-view-Contact-vue":"home-view-Contact-vue","home-view-ContentDetail-vue":"home-view-ContentDetail-vue","home-view-FoundationProfile-vue":"home-view-FoundationProfile-vue","home-view-Ikamaku-vue":"home-view-Ikamaku-vue","home-view-OrganizationStructure-vue":"home-view-OrganizationStructure-vue","home-view-UnitProfile-vue":"home-view-UnitProfile-vue","home-view-ContentList-vue":"home-view-ContentList-vue","npm.cropperjs":"npm.cropperjs","siakad-AdmissionChildren-vue~siakad-Attendance-vue~siakad-AttendanceAndAgenda-vue~siakad-ChildrenDet~58a56ef4":"siakad-AdmissionChildren-vue~siakad-Attendance-vue~siakad-AttendanceAndAgenda-vue~siakad-ChildrenDet~58a56ef4","siakad-ChildrenDetail-vue~siakad-ParentDetail-vue~siakad-Siakad-vue":"siakad-ChildrenDetail-vue~siakad-ParentDetail-vue~siakad-Siakad-vue","siakad-ChildrenDetail-vue":"siakad-ChildrenDetail-vue","siakad-ParentDetail-vue":"siakad-ParentDetail-vue","siakad-Siakad-vue":"siakad-Siakad-vue","npm.v-calendar":"npm.v-calendar","npm.popperjs":"npm.popperjs","siakad-Attendance-vue":"siakad-Attendance-vue","siakad-AttendanceAndAgenda-vue":"siakad-AttendanceAndAgenda-vue","siakad-AdmissionChildren-vue":"siakad-AdmissionChildren-vue","siakad-ChildrenHistory-vue":"siakad-ChildrenHistory-vue","siakad-Agenda-vue":"siakad-Agenda-vue","siakad-ClassHistory-vue":"siakad-ClassHistory-vue","siakad-EkstrakurikulerHistory-vue":"siakad-EkstrakurikulerHistory-vue","siakad-FriendHistory-vue":"siakad-FriendHistory-vue","siakad-HelpCenter-vue~siakad-Suggestions-vue":"siakad-HelpCenter-vue~siakad-Suggestions-vue","siakad-HelpCenter-vue":"siakad-HelpCenter-vue","siakad-Suggestions-vue":"siakad-Suggestions-vue","siakad-PaymentHistory-vue":"siakad-PaymentHistory-vue","siakad-SubjectHistory-vue":"siakad-SubjectHistory-vue","siakad-SubjectList-vue":"siakad-SubjectList-vue","view-ForgetPassword-vue":"view-ForgetPassword-vue","view-Login-vue":"view-Login-vue","view-RegistrationForm-vue":"view-RegistrationForm-vue","view-Verify-vue":"view-Verify-vue","siakad-FaqDetail-vue":"siakad-FaqDetail-vue","siakad-Report-vue":"siakad-Report-vue","view-Logout-vue":"view-Logout-vue","view-Welcome-vue":"view-Welcome-vue"}[chunkId]||chunkId) + "." + {"home-view-Contact-vue":"31d6cfe0","home-view-ContentDetail-vue":"31d6cfe0","home-view-FoundationProfile-vue":"31d6cfe0","home-view-Ikamaku-vue":"31d6cfe0","home-view-OrganizationStructure-vue":"31d6cfe0","home-view-UnitProfile-vue":"31d6cfe0","home-view-ContentList-vue":"31d6cfe0","npm.cropperjs":"2f409942","siakad-AdmissionChildren-vue~siakad-Attendance-vue~siakad-AttendanceAndAgenda-vue~siakad-ChildrenDet~58a56ef4":"31d6cfe0","siakad-ChildrenDetail-vue~siakad-ParentDetail-vue~siakad-Siakad-vue":"31d6cfe0","siakad-ChildrenDetail-vue":"31d6cfe0","siakad-ParentDetail-vue":"31d6cfe0","siakad-Siakad-vue":"31d6cfe0","npm.v-calendar":"31d6cfe0","npm.popperjs":"31d6cfe0","siakad-Attendance-vue":"31d6cfe0","siakad-AttendanceAndAgenda-vue":"31d6cfe0","siakad-AdmissionChildren-vue":"31d6cfe0","siakad-ChildrenHistory-vue":"31d6cfe0","siakad-Agenda-vue":"31d6cfe0","siakad-ClassHistory-vue":"31d6cfe0","siakad-EkstrakurikulerHistory-vue":"31d6cfe0","siakad-FriendHistory-vue":"31d6cfe0","siakad-HelpCenter-vue~siakad-Suggestions-vue":"31d6cfe0","siakad-HelpCenter-vue":"31d6cfe0","siakad-Suggestions-vue":"31d6cfe0","siakad-PaymentHistory-vue":"31d6cfe0","siakad-SubjectHistory-vue":"31d6cfe0","siakad-SubjectList-vue":"31d6cfe0","view-ForgetPassword-vue":"31d6cfe0","view-Login-vue":"31d6cfe0","view-RegistrationForm-vue":"31d6cfe0","view-Verify-vue":"b9c37fd4","siakad-FaqDetail-vue":"31d6cfe0","siakad-Report-vue":"31d6cfe0","view-Logout-vue":"9574354f","view-Welcome-vue":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
